export default __webpack_public_path__ + "static/subset-Aeroport-4fdfc5e0a350447debbaceff2373c086.woff2";